import DateUtils from '@/utils/dateUtils'

export class TosNodeMessageUtils {
  constructor() {
  }

  getNodeMessageObject() {
    const item = {}
    item.startMessage = startMessage
    item.startMessage2 = startMessage2
    item.toTheFactoryMessage = toTheFactoryMessage
    item.toTheFactoryMessage2 = toTheFactoryMessage2
    item.offFactoryMessage = offFactoryMessage
    item.offFactoryMessage2 = offFactoryMessage2
    item.customsReleaseMessage = customsReleaseMessage
    item.customsReleaseMessage2 = customsReleaseMessage2
    item.wharfReleaseMessage = wharfReleaseMessage
    item.wharfReleaseMessage2 = wharfReleaseMessage2
    item.aboardMessage = aboardMessage
    item.aboardMessage2 = aboardMessage2
    item.arrivalPortMessage = arrivalPortMessage
    item.arrivalPortMessage2 = arrivalPortMessage2
    item.departureFromMessage = departureFromMessage
    item.departureFromMessage2 = departureFromMessage2
    item.returnBoxMessage = returnBoxMessage
    item.returnBoxMessage2 = returnBoxMessage2
    return item
  }

  getMessageByType(type, time, nTime) {
    const object = this.getNodeMessageObject()
    let text = ''
    if (nTime != null) {
      text = object[type + '2'].replace('${time}', this.pageDate(time))
      text = text.replace('${nTime}', this.pageDate(nTime))
    } else {
      text = object[type].replace('${time}', this.pageDate(time))
    }
    return text
  }

  /**
   * 标准的详细时间
   * @param date
   */
  pageDate(date) {
    if (date == null) return ' 暂无 '
    return DateUtils.customFormat(date, DateUtils.STANDARD_MINUTE_TIME)
  }
}

// 【出发码头】
export const startMessage = '最晚出发提箱时间是${time} 还未出发'
export const startMessage2 = '最晚出发提箱时间是${time} 实际出发提柜时间是：${nTime}'
// 【到厂】
export const toTheFactoryMessage = '客户要求到厂时间是${time}，还未到厂'
export const toTheFactoryMessage2 = '客户要求到厂时间是${time}，实际到厂时间是：${nTime}'
// 【离厂】
export const offFactoryMessage = '最晚离场时间是${time}，还未离厂'
export const offFactoryMessage2 = '最晚离场时间是${time}，实际离厂时间是：${nTime}'
// 【海关放行】
export const customsReleaseMessage = '截关时间${time}，海关放行时间暂无'
export const customsReleaseMessage2 = '截关时间${time}，实际海关放行时间：${nTime}'
// 【码头放行】
export const wharfReleaseMessage = '最晚码头放行时间是${time}，实际暂无'
export const wharfReleaseMessage2 = '最晚码头放行时间是${time}，实际码头放行时间是：${nTime}'
// 【上船】
export const aboardMessage = '最晚上船时间是${time}，还未上船'
export const aboardMessage2 = '最晚上船时间是${time}，实际上船时间是：${nTime}'
// 【离港】
export const departureFromMessage = '最晚离港时间是${time}，还未离港'
export const departureFromMessage2 = '最晚离港时间是${time}，实际离港时间是：${nTime}'
// 【到港】
export const arrivalPortMessage = '最晚到港时间是${time}，还未到港'
export const arrivalPortMessage2 = '最晚到港时间是${time}，实际到港时间是：${nTime}'
// 【还箱】
export const returnBoxMessage = '最晚还箱时间是${time}，还未还箱'
export const returnBoxMessage2 = '最晚还箱时间是${time}，实际还箱时间是：${nTime}'

